import { Typography } from 'antd';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import RestList from 'containers/rest/List';
import { DynamicObjectType } from 'core/types/common';
import React from 'react';
import { FilterFromUrlResponseType } from 'types/commons';
import { getDataDetail } from 'utils/tools';

const ItemsList = ({
  selectedData,
}: {
  selectedData: any;
  isDetail?: boolean;
}) => {
  const restInitialFilter: FilterFromUrlResponseType & { outSideFilter: any } =
    {
      join: [],
      filters: [],
      outSideFilter: {
        transferIds: `[${selectedData}]`,
      },
    };

  const columns: IRestColumnProps[] = [
    {
      name: 'variantSku',
      title: 'SKU',
      render: (d: string) => (
        <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ width: 150 }}>
          {d}
        </Typography.Paragraph>
      ),
      isDefault: true,
    },
    {
      name: 'variantName',
      title: 'SKU Name',
      isDefault: true,
      render: (d: string, rc: DynamicObjectType) => {
        return (
          <>
            <div>{d || ''}</div>
            <div className="text-sm text-secondary">
              {rc?.attributeValues
                ?.map((item) => getDataDetail(item)?.name)
                ?.join('/')}
            </div>
          </>
        );
      },
    },
    {
      name: 'itemsCount',
      title: 'Number of items',
      isDefault: true,
    },
  ];
  return (
    <RestList
      initialFilter={restInitialFilter}
      columns={columns}
      model="itemOrders"
      hasOnlyFilter
      hasShowFilter={false}
      hasImport={false}
      hasExport={false}
      hasCustomLayout
      defaultOptions={{
        customApiResource: `transfer-orders/view-items`,
      }}
      searchKeys={['items.variantSku']}
      placeholderInputSearch="Search SKU"
      ignoreDefault
    />
  );
};

export default ItemsList;
